export const UNLOCK_SOUNDS = ["/sounds/Unlock01.mp3", "/sounds/Unlock02.mp3", "/sounds/Unlock03.mp3"];

export const playUnlockSound = (): void => {
  const src = UNLOCK_SOUNDS[Math.floor(Math.random() * UNLOCK_SOUNDS.length)];
  const audio = new Audio(src);
  audio.volume = 0.6;
  void audio.play().catch(() => undefined);
};
